module.exports = __webpack_public_path__ + "static/media/personalizado.16a230cc.svg";